import { contextFactory } from "../../../utils/contextFactory";
import type { ModalProps } from "../Modal";

const [ModalProvider, useModalContext] = contextFactory<ModalProps>({
  displayName: "ModalProvider",
  errorMessage: "Modal components should be wrapped in a `Modal`.",
});

export { ModalProvider, useModalContext };
